import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=1ef30131&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"
import style0 from "./Tournaments.vue?vue&type=style&index=0&id=1ef30131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef30131",
  null
  
)

export default component.exports